import React, {Suspense} from 'react';
import {ContentRoute, LayoutSplashScreen} from "../../../../_metronic/layout";
import {Redirect, Switch} from "react-router-dom";
import {OrdersListPage} from "../../Sale/pages/orders-list/OrdersListPage";
import {OrdersListSingle} from "../../Sale/pages/orders-list/orders-list-single/OrdersListSingle";


export default function ReportsPage() {
    return (
        <Suspense fallback={<LayoutSplashScreen/>}>
            <Switch>
                {
                    <Redirect exact={true}
                              from={"/reports"}
                              to={"/reports/sales"}
                    />
                }
                <ContentRoute path={"/reports/sales/:id"} component={OrdersListSingle}/>
                <ContentRoute path={"/reports/sales"} component={OrdersListPage}/>
            </Switch>
        </Suspense>
    )
}